import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  inject,
} from '@angular/core';
import { BookingNode } from '@generated/graphql';
import { RoutingService } from '@app/shared/services/routing.service';

@Component({
  selector: 'result-bookings-block',
  templateUrl: './result-bookings-block.component.html',
  styleUrls: ['./result-bookings-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultBookingsBlockComponent {
  @Input() bookings?: BookingNode[];
  @Output() rowClick = new EventEmitter();

  routingService = inject(RoutingService);

  openBooking(event: MouseEvent, booking: BookingNode) {
    const queryParams = { booking: booking.id };
    this.routingService.navigateTo(['orders', booking.order?.id as string], event, { queryParams });
  }
}
